import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const LinkType = z.enum([
  'Slide',
  'Site',
]);
export type LinkType = z.infer<typeof LinkType>;

export const LinkTypeArray = Object.values(LinkType.enum).map(value => { return { value: value, name: 'enum.link.' + value }; });

export const LinkEmptySchema = z.object({
  type: z.literal(null),
  link: z.string().url().nullable().default(null),
});

export const LinkUrlSchema = z.object({
  type: z.literal('Site'),
  link: z.string().url().nullable().default(null),
});

export const LinkSlideSchema = z.object({
  type: z.literal('Slide'),
  link: z.union([z.number(), z.string()]).nullable().default(null),
});

export const LinkSchema = z.discriminatedUnion('type', [LinkEmptySchema, LinkUrlSchema, LinkSlideSchema]);

export type Link = z.infer<typeof LinkSchema>;

export const LinkEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: LinkSchema,
});

export type LinkEntityQueryResult = z.infer<typeof LinkEntityQueryResultSchema>;
